import * as React from "react";
import OutlinedInput from "@mui/material/OutlinedInput";
import MenuItem from "@mui/material/MenuItem";
import ListItemText from "@mui/material/ListItemText";
import { SelectChangeEvent } from "@mui/material/Select";
import Checkbox from "@mui/material/Checkbox";
import { Box, Chip, styled } from "@mui/material";
import { StyledSelect as Select } from "components/Input/styled";
import { findValue } from "./functions";
import { useDispatch, useSelector } from "react-redux";
import { updateForm } from "store/actions/formAction";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const StyledSelect = styled(Select)(({ theme }) => ({
  width: "100%",
  "&.MuiOutlinedInput-root": {
    border: `solid 2px ${theme.palette.disabled.contrastText}`,
    borderRadius: "4px",
    height: "fit-content",
    width: "100%",
    padding: "0px",
    minHeight: "40px",
  },
  ".css-1d9mq0f-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input": {
    padding: 5,
  },
}));

export default function MultipleSelect({
  option,
  name,
}: {
  option: {
    title: string;
    value: string;
  }[];
  name: string;
}) {
  // const [selected, setSelected] = React.useState<string[]>([]);

  const dispatch = useDispatch();

  const handleChange = (event: SelectChangeEvent<any[]>) => {
    const {
      target: { value },
    } = event;
    return dispatch(updateForm(name, typeof value === "string" ? value.split(",") : value));
  };

  //@ts-ignore
  const formData = useSelector((state) => state).formReducer;
  //@ts-ignore
  const editItem = useSelector((state) => state.formReducer.editItem);
  const formType = "form";

  const defaultValue = editItem?.accessTimeLimit[name] || [];

  // const defaultValue = ''
  const selected = findValue(formData, formType, name, editItem ? editItem[name] : defaultValue) || [];
  return (
    <div>
      <StyledSelect
        labelId="demo-multiple-checkbox-label"
        id="demo-multiple-checkbox"
        multiple
        value={selected}
        // @ts-ignore
        onChange={handleChange}
        input={<OutlinedInput id="select-multiple-chip" label="Chip" />}
        // @ts-ignore
        renderValue={(selected) => (
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
            {/* @ts-ignore */}
            {selected.map((value) => (
              <Chip key={value} label={value} />
            ))}
          </Box>
        )}
        MenuProps={MenuProps}
      >
        {option.map((item, index) => (
          <MenuItem
            sx={{ display: "flex", flexDirection: "row-reverse" }}
            key={item.title}
            value={item.title}
          >
            <Checkbox checked={selected.indexOf(item.title) > -1} />
            <ListItemText sx={{ textAlign: "right" }} primary={item.title} />
          </MenuItem>
        ))}
      </StyledSelect>
    </div>
  );
}
